import {baseUrl, buildQueryParams} from './Requests.js'

function getCompanyNews(ticker, size, datefrom, dateto) {
  const queryParams = {
    size: size,
    page: 1,
    limit: 1
  };

  if (ticker && ticker !== 'None') {
    queryParams.ticker = ticker;
  }
  if (datefrom) {
    queryParams.datefrom = datefrom;
  }
  if (dateto) {
    queryParams.dateto = dateto;
  }

  const params = buildQueryParams(queryParams);
  return (
    fetch(`${baseUrl}/companynews?${params.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
  )
}

export { getCompanyNews };